import { render, staticRenderFns } from "./freeRoomReport.vue?vue&type=template&id=71d8a3f4"
import script from "./freeRoomReport.vue?vue&type=script&lang=js"
export * from "./freeRoomReport.vue?vue&type=script&lang=js"
import style0 from "./freeRoomReport.vue?vue&type=style&index=0&id=71d8a3f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports